import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getPadding = (dsf_size) => {
  switch (dsf_size) {
    case "large":
      return "p-16";
    case "small":
      return "p-8";
    default:
      return "p-12";
  }
};
const getWrapperClasses = ({ dsf_borderless }) => {
  const classes = ["flex", "flex-col", "w-full", "border-neutral-100", "rounded"];
  if (!dsf_borderless) {
    classes.push("border", "shadow-xs");
  }
  return concatClasses(classes);
};
const getHeaderClasses = ({ dsf_size }) => {
  const classes = [
    "flex",
    getPadding(dsf_size),
    "justify-between",
    "items-center",
    "outline-none",
    "group"
  ];
  return concatClasses(classes);
};
const getIconClasses = ({ dsf_open }) => {
  const classes = [
    "rounded-sm",
    "border",
    "border-neutral-0",
    "group-focus-visible:border-secondary-300",
    "group-focus-visible:shadow-focus-secondary-md",
    "cursor-pointer"
  ];
  if (dsf_open) {
    classes.push("rotate-180");
  }
  return concatClasses(classes);
};
export {
  getHeaderClasses,
  getIconClasses,
  getWrapperClasses
};
